<template>
  <footer class="black-footer">
    <div class="social-icons">
      <a :href="generalSetting.facebooklink" class="icon">
        <i class="fa-brands fa-facebook"></i>
      </a>
      <a :href="generalSetting.instagramlink_1" class="icon">
        <i class="fa-brands fa-instagram"></i>
      </a>
      <a :href="generalSetting.instagramlink_2" class="icon">
        <i class="fa-brands fa-instagram"></i>
      </a>
    </div>
    <div class="contact-info">
      <div class="address">
        <i class="fa-sharp fa-solid fa-location-dot addressIcon"></i>
        <span v-if="this.currentLang === 'ar'">{{
          generalSetting.location_ar
        }}</span>
        <span v-if="this.currentLang === 'en'">{{
          generalSetting.location_en
        }}</span>
      </div>
      <div class="mobile">
        <i class="fas fa-phone mobileIcon"></i
        ><span>{{ generalSetting.phone_1 }}</span>
      </div>
      <div class="whatsapp">
        <i class="fa-brands fa-whatsapp whatsappIcon"></i
        ><span>{{ generalSetting.phone_2 }}</span>
      </div>
    </div>
    <!---->
    <MapView style="width: 30%; height: 250px; margin-left: 8%" />
    <!---->
    <div class="logo">
      <img :src="logoSrc" alt="Logo" />
    </div>
  </footer>
</template>

<script>
import Axios from "../../Axios";
import store from "../../store";
import { mapState } from "vuex";
import MapView from "../SharedUI/MapView.vue";

export default {
  name: "Footer",
  components: {
    MapView,
  },
  data() {
    return {
      generalSetting: {},
      logoSrc: require("../../assets/images/logo.png"),
      langVar: store.state.currentLang,
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
  mounted() {
    this.fetchGeneralSetting();
  },
  methods: {
    fetchGeneralSetting() {
      Axios
        .get("/generalSetting")
        .then((response) => {
          this.generalSetting = {
            email: response.data.email,
            location_en: response.data.location_en,
            location_ar: response.data.location_ar,
            phone_1: response.data.phone_1,
            phone_2: response.data.phone_2,
            facebooklink: response.data.facebooklink,
            instagramlink_1: response.data.instagramlink_1,
            instagramlink_2: response.data.instagramlink_2,
          };
          // console.log(this.generalSetting, "aaaaaaa");
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.black-footer {
  background-color: #2b2b2b;
  color: #fff;
  padding: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 100px;
}

.icon {
  color: #fff;
  font-size: 30px;
  margin-right: 10px;
}

.icon:hover {
  color: #f9c752;
}

.logo img {
  max-height: 200px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.phoneIcon,
.mobileIcon,
.whatsappIcon,
.addressIcon {
  font-size: 22px;
  margin-left: 4%;
  margin-top: 8px;
}
</style>

<style scoped>
.black-footer {
  background-color: #2b2b2b;
  color: #fff;
  padding: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 100px;
}

.icon {
  color: #fff;
  font-size: 30px;
  margin-right: 10px;
}

.icon:hover {
  color: #f9c752;
}

.logo img {
  max-height: 200px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin-right: 5%;
}

.phoneIcon,
.mobileIcon,
.whatsappIcon,
.addressIcon {
  font-size: 22px;
  margin-left: 4%;
  margin-top: 8px;
}
@media (max-width: 768px) {
  .leaflet-container {
    width: 100% !important;
  }
  .black-footer{
    display: block;
    text-align: center;
  }
  .contact-info{
    margin: 0;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
</style>